module.exports = __webpack_public_path__ + "static/media/at-the-barn.4a0fb146.jpg";